import get from "lodash/get"
import axios from "axios"
import { urls } from "utils-lib/builds"
import { generateUniqueID } from "utils-lib/requests"
import { mapToCamelFromSnake } from "utils-lib/objects"
import { mapToSnakeFromCamel } from "utils-lib/objects/mapToSnakeFromCamel"
import {
  UPDATE_UNSUBSCRIBE_FEEDBACK_PENDING,
  UPDATE_UNSUBSCRIBE_FEEDBACK_FAILED,
  UPDATE_UNSUBSCRIBE_FEEDBACK_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: UPDATE_UNSUBSCRIBE_FEEDBACK_PENDING,
})

export const failedAC = (data) => ({
  type: UPDATE_UNSUBSCRIBE_FEEDBACK_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: UPDATE_UNSUBSCRIBE_FEEDBACK_FULFILLED,
  payload: data,
})

export const sendUnsubscribeFeedback = (data) => (dispatch) => {
  const api = `UNSUBSCRIBE_FEEDBACK`
  const url = urls.url[api]
  const mappedPayload = mapToSnakeFromCamel(data)

  dispatch(pendingAC())

  const config = {
    headers: {
      "Request-Tracking-Id": generateUniqueID(),
    },
  }

  return axios
    .create(config)
    .put(url, mappedPayload)
    .then((response) => {
      const mappedPutResponse = mapToCamelFromSnake(response.data)
      dispatch(fulfilledAC(response.data))

      return mappedPutResponse
    })
    .catch((error) => {
      const errorCode = get(error, `response.status`, ``)
      dispatch(failedAC(errorCode))

      return errorCode
    })
}
